import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "../locales/en/common.json";
import ozCommon from "../locales/oz/common.json";
import ruCommon from "../locales/ru/common.json";
import uzCommon from "../locales/uz/common.json";

// Initialize synchronously for SSR compatibility
i18n.use(initReactI18next).init({
  resources: {
    uz: { common: uzCommon },
    oz: { common: ozCommon },
    ru: { common: ruCommon },
    en: { common: enCommon },
    default: { common: ozCommon },
  },
  defaultNS: "common",
  fallbackLng: "oz",
  lng: "oz",
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["path"],
    lookupFromPathIndex: 0,
  },
  // Required for SSR - prevents async issues
  react: {
    useSuspense: false,
  },
  // Initialize synchronously
  initImmediate: false,
});

export default i18n;
